import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const StyledFooterBackToTopButton = styled.button(
  ({ theme }) => `
    display: flex;
    gap: ${theme.size.static150};
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    flex-direction: row-reverse;
    padding: 0;

    @media (min-width: ${Breakpoints.b1280}px) {
        flex-direction: column;
      }
  `
);
